import { AbstractControl, ValidationErrors } from '@angular/forms';

export class NameValidators {
  static allCaps(control: AbstractControl): ValidationErrors | null {
    const value: string = control.value?.trim() || '';

    if (!value) {
      return null; // Allow empty
    }


    // Step 1: Skip strict validation if any lowercase letter exists
    if (/[a-z]/.test(value)) {
      return null;
    }

    // Step 2: Match all uppercase word segments
    const uppercaseWords = value.match(/[A-Z']+/g) || [];

    let twoLetterCount = 0;

    for (const word of uppercaseWords) {
      // Apostrophe check (e.g., O'N)
      if (word.includes("'")) {
        if (!/^[A-Z]('[A-Z])$/.test(word)) {
          return { allCaps: true }; // Invalid apostrophe format
        }
        continue;
      }

      if (word.length === 1) {
        continue; // single uppercase letter is okay
      }

      if (word.length === 2) {
        twoLetterCount++;
        if (twoLetterCount > 1) {
          return { allCaps: true }; // more than one 2-letter word
        }
        continue;
      }

      // 3 or more uppercase letters in a word
      return { allCaps: true };
    }

    return null; // Valid
  }
}
 